import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, Box, CircularProgress } from '@mui/material';
export default function Loading(props) {
    const { message } = props;
    return (_jsxs(Backdrop, { sx: { color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }, open: true, children: [message && _jsxs("div", { style: { marginRight: '12px' }, children: [message, "..."] }), _jsx(CircularProgress, { color: "inherit" })] }));
}
export function SimpleLoading(props) {
    const { message } = props;
    return (_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", children: [message && _jsxs("div", { style: { marginRight: '12px' }, children: [message, "..."] }), _jsx(CircularProgress, { color: "inherit" })] }));
}
export function LoadingSpinner() {
    return _jsx(CircularProgress, { sx: { mr: '2px', color: '#007ca3', verticalAlign: 'middle' }, size: 18, color: "inherit" });
}
